import React, { PureComponent } from "react";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import style from './styles.module.scss';
import AppBar from '@material-ui/core/AppBar';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    progress: {
        backgroundColor: '#b08f6e4d',
        margin: -2,
        height: 2,
        marginLeft: 0,
        marginRight: 0,
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: '#b08f6e'
        }
    }
}));

export const StyledLinearProgress = ({show, style={}}) => {
    const classes = useStyles();
    return (<LinearProgress classes={{ root: classes.progress }} style={{ opacity: show ? 1 : 0, ...style }} />);
}

const SingleAndParcelsTabs = (props) => {
    const { value, onChange, areDiamondsLoading, isAuthorised, appBarStyle, hideLinearProgress, showColourDiamonds } = props;
    const classes = useStyles();

    return (
        <AppBar position="static" color="transparent" classes={{ root: style.tabsWrapper }} style={appBarStyle}>
            <Tabs value={value} onChange={onChange} indicatorColor="primary" >
                <Tab label={'Natural'} />
                <Tab label={'Lab Grown'} />
                <Tab label={'Parcels'} />
                {showColourDiamonds && <Tab label={'Coloured'} />}
            </Tabs>
            {!hideLinearProgress && <StyledLinearProgress show={areDiamondsLoading} />}
        </AppBar>
    );
}

export default connect(
    (state) => ({
        areDiamondsLoading: !state.diamonds || !state.diamonds.data || !state.diamonds.data.docs || !state.diamonds.data.docs.length,
        isAuthorised: state.auth.isAuthorised,
    }),
)(SingleAndParcelsTabs);
